import { SupplyFitEngine } from "../types";

export const supplyFitEngines: SupplyFitEngine[] = [
  {
    id: 1,
    image: "/engines/engine_1.webp",
    title: "Range Rover Sport SVR 5.0L Supercharger AJ133 GEN1",
    description:
      "Fully tested AJ133 GEN1 supercharged unit, supplied and fitted with strict compression and pressure checks completed beforehand.",
    specs: [
      "Warranty included",
      "Ancillaries transferred",
      "Fitted in-house",
    ],
  },
  {
    id: 2,
    image: "/engines/engine_2.webp",
    title: "Range Rover Sport SVR 5.0L Supercharger AJ133 GEN2",
    description:
      "AJ133 supercharged engine sourced, tested and fitted to restore full SVR performance without main dealer pricing.",
    specs: [
      "Low mileage stock",
      "Full diagnostics run",
      "Same-week fitting",
      
    ],
  },
  {
    id: 3,
    image: "/engines/engine_3.webp",
    title: "Range Rover Sport 3.0L Petrol Supercharger AJ133 GEN1",
    description:
      "A dependable 3.0 petrol supercharged AJ133 engine, checked and fitted with all ancillaries carried across correctly.",
    specs: [
      "Compression tested",
      "Warranty backed",
      "Nationwide collection",
      
    ],
  },
  {
    id: 4,
    image: "/engines/engine_4.webp",
    title: "Land Rover 2.0L Diesel 204DTD 177 hp",
    description:
      "Reconditioned 204DTD unit supplied and fitted, giving Discovery Sport and Evoque owners a reliable, tested replacement.",
    specs: [
      "Fully reconditioned",
      "Fitted by specialists",
      "Warranty included",
      
    ],
  },
  {
    id: 5,
    image: "/engines/engine_5.webp",
    title: "Land Rover 2.0L Diesel 204DTA Twin Turbo 237hp",
    description:
      "Twin-turbo 204DTA engine supplied and fitted, restoring the stronger power delivery this unit is known for.",
    specs: [
      "Twin turbo tested",
      "Ancillaries transferred",
      "Fast turnaround",
      
    ],
  },
  {
    id: 6,
    image: "/engines/engine_6.webp",
    title: "Land Rover Range Rover 3.0 TDV6 306DT GEN1",
    description:
      "GEN1 TDV6 306DT engine, pressure and compression tested before fitting to Range Rover and Discovery models.",
    specs: [
      "Fully tested unit",
      "Warranty backed",
      "UK-wide delivery",
      
    ],
  },
  {
    id: 7,
    image: "/engines/engine_7.webp",
    title: "Land Rover Range Rover 3.0 TDV6 306DT GEN2",
    description:
      "Updated GEN2 TDV6 engine supplied and fitted with careful attention to timing chain and seal condition.",
    specs: [
      "Timing chain checked",
      "Low mileage options",
      "Fitted in-house",
      
    ],
  },
  {
    id: 8,
    image: "/engines/engine_8.webp",
    title: "Range Rover 4.4 Diesel Bare Engine TDV8 448DT",
    description:
      "Bare TDV8 448DT block available for supply, ideal where existing ancillaries are being retained and reused.",
    specs: [
      "Bare engine option",
      "Compression verified",
      "Collection available",
      
    ],
  },
  {
    id: 9,
    image: "/engines/engine_9.webp",
    title: "Range Rover Evoque 2.0L Petrol P250 PT204 (MHEV)",
    description:
      "Mild-hybrid PT204 engine supplied and fitted with full attention to the MHEV system's specific requirements.",
    specs: [
      "MHEV compatible",
      "Fully tested",
      "Warranty included",
      
    ],
  },
  {
    id: 10,
    image: "/engines/engine_10.webp",
    title: "Range Rover Sport P400E AJ200P PT204 (PHEV)",
    description:
      "Plug-in hybrid AJ200P engine supplied and fitted with careful integration alongside existing hybrid components.",
    specs: [
      "PHEV specialist fit",
      "Ancillaries checked",
      "Nationwide service",
      
    ],
  },
  {
    id: 11,
    image: "/engines/engine_11.webp",
    title: "Range Rover Evoque 2.0L Petrol 204PT Recon.",
    description:
      "Reconditioned 204PT petrol engine supplied and fitted, tested thoroughly to confirm smooth, reliable running.",
    specs: [
      "Reconditioned to spec",
      "Warranty backed",
      "Fast fitting",
      
    ],
  },
  {
    id: 12,
    image: "/engines/engine_12.webp",
    title: "Land Rover Defender 110 HSE 2.0 Diesel 204DTA",
    description:
      "204DTA engine supply and fit for the Defender 110 HSE, matched precisely to original specification.",
    specs: [
      "Precision matched",
      "Fully tested",
      "UK-wide collection",
      
    ],
  },
  {
    id: 13,
    image: "/engines/engine_13-white.webp",
    title: "Land Rover Defender 130 3.0 Diesel D200 DT306",
    description:
      "D200 DT306 diesel engine supplied and fitted for the Defender 130, checked against factory tolerances.",
    specs: [
      "Factory spec tested",
      "Warranty included",
      "Fitted by experts",
      
    ],
  },
  {
    id: 14,
    image: "/engines/engine_14.webp",
    title: "L663 Land Rover Defender 110 3.0 Inline Diesel",
    description:
      "3.0 diesel unit for the L663 Defender 110, supplied and fitted with full diagnostic verification.",
    specs: [
      "Diagnostics verified",
      "Ancillaries transferred",
      "Fast turnaround",
      
    ],
  },
  {
    id: 15,
    image: "/engines/engine_15.webp",
    title: "Range Rover Evoque 2.0L Petrol P250 AJ20P4",
    description:
      "AJ20P4 petrol engine supplied and fitted, restoring reliable performance to the Evoque P250 range.",
    specs: [
      "Fully reconditioned",
      "Warranty backed",
      "Same-week fitting",
      
    ],
  },
  {
    id: 16,
    image: "/engines/engine_16.webp",
    title: "Land Rover Ingenium Range Rover P400e 2.0 Petrol",
    description:
      "Ingenium P400e petrol engine supply and fit, carried out with careful hybrid system compatibility checks.",
    specs: [
      "Ingenium specialist",
      "Hybrid checked",
      "Nationwide delivery",
      
    ],
  },
];